import React from 'react';
import { PainSection } from './PainSection';
import { ProductIntro } from './ProductIntro';
import { TomosSection } from './TomosSection';
import { BonosSection } from './BonosSection';
import { ValueStack } from './ValueStack';
import { AudienceSection } from './AudienceSection';
import { Testimonials } from './Testimonials';
import { HowItWorks } from './HowItWorks';
import { Guarantee } from './Guarantee';
import { ClosingBlock } from './ClosingBlock';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
import { SocialProofPopup } from './SocialProofPopup';
import { FloatingCTA } from './FloatingCTA';
export function DeferredLanding() {
  return <>
      <PainSection data-id="element-56" data-mp="x0wxx0r4ejkh" />
      <ProductIntro data-id="element-57" data-mp="x0dflixk5t5x" />
      <TomosSection data-id="element-58" data-mp="x1y7t1weh00m" />
      <BonosSection data-id="element-59" data-mp="x2q5qjdgz9u2" />
      <ValueStack data-id="element-60" data-mp="1bxxeq97rwu46" />
      <AudienceSection data-id="element-61" data-mp="1bxe99rzb7y71" />
      <Testimonials data-id="element-62" data-mp="1bypb3m972vvi" />
      <HowItWorks data-id="element-63" data-mp="1by5t65jjo7hh" />
      <Guarantee data-id="element-64" data-mp="1bvjjo0d3fhwm" />
      <ClosingBlock data-id="element-65" data-mp="16z2zfh90lnot" />
      <FAQ data-id="element-66" data-mp="16zm6g2x4mro2" />
      <Footer data-id="element-67" data-mp="17049bieao44y" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-68" data-mp="170dy52nls592" />
      <SocialProofPopup data-id="element-69" data-mp="1xxoyeoap5301" />
      <FloatingCTA data-id="element-70" data-mp="1xy8d7w51vb9u" />
    </>;
}